import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CategoryFilterEntity } from '../../domain/entities/CategoryFilterEntity'

export class CategoryFilterModel extends CategoryFilterEntity {
   channelId?: number
  branchId?: number
  constructor(dataDto: CategoryFilterEntity) {
    super()
    mapEntityProperties<CategoryFilterModel>(this, dataDto, {
      exclude: ['channel', 'branch'],
      map: {
        channelId: dataDto.channel?.id,
        branchId: dataDto.branch?.id
      }
    })
  }
}
